<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查统计
      </div>
    </div>
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <div class="common-page common-tool-bar" style="justify-content: end">
          <div>
            <el-button type="success" size="small" v-hasPermi="['relic:inspectionStatistics:export']" @click="outPut">导出数据</el-button>

            <el-button type="primary" size="small"  @click="showDia = true">查询</el-button>
          </div>
        </div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column prop="pointNum" label="巡查点编号" align="center"> </el-table-column>
            <el-table-column prop="pointName" label="巡查点名称" align="center"> </el-table-column>
            <el-table-column prop="pointAddr" label="巡查点位置" align="center"> </el-table-column>
            <el-table-column prop="areaName" align="center" label="所在区域"> </el-table-column>
            <el-table-column prop="pointStatusStr" align="center" label="巡查点状态">
              <!-- <template slot-scope="scope">
                <el-button type="info" size="mini" plain v-if="scope.row.c_point_error == null">待检查</el-button>
                <el-button v-else plain size="mini" :type="scope.row.c_point_error == 0 ? 'info' : scope.row.c_point_error == 1 ? 'danger' : 'success'">
                  {{ $map.isNormal[scope.row.c_point_error] }}
                </el-button>
              </template> -->
            </el-table-column>
            <el-table-column prop="count" align="center" label="巡查次数"> </el-table-column>

            <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <!-- v-hasPermi="['safe:time:edit']" -->
                <router-link
                  :to="{
                    path: '/wenlv/inspectionRecord',
                    query: { id: scope.row.pointNum },
                  }"
                  
                >
                  <el-button size="mini" type="primary">详情</el-button>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination :current-page.sync="pageNum"   background layout="prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-size="10" :total="total"> </el-pagination>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from '@/components/unitList1';
export default {
  data() {
    return {
      list: [],
      params: {
        pageNum: 1,
         pointNum: '',
        pointAddr: '',
         pointError: '',
        companyNum:  this.$store.state.user.company.cCompanyNum||this.cpNum,
        startTime: '',
        endTime: '',
        c_point_area: '',
      },
      cpNum: '',

      outPutForm: {},
      total: 0,
      showDia: false,
      searchForm: this.$getForm('xctongjiSearch'),
      editData: {},
      remoteFuncs: {},
       pageNum: 1,
       pageSize: 10,
    };
  },
  created() {
    // this.getList();
  },
  components: {
    unitList,
  },
  watch: {
    cpNum() {
      this.params.companyNum = this.cpNum;
      this.params.pageNum = 1;
      // this.getDatas()
      this.getList();
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val; //更新每页的条数
          console.log('handleSizeChange');

      this.getList(); //重新获取列表数据
    },
    handleCurrentChange(val) {
          console.log(val,'handleCurrentChange');
this.params.pageNum = val;
      this.pageNum = val; //重新获取列表数据
      this.getList();
    },
    cancle() {
      // this.showDia = false;
      this.resetSearch();
    },
    //导出
    outPut() {
      
            this.$get(
        "/relic/relicInspectionRecords/exportInspectionStatistics",
        this.params
      ).then((res) => {
        // console.log(res);
        // console.log(this.download)
         this.download(res.msg)
      });
    //   this.downLoadExcel('/inspection/wenwuInspectionAppMain/export', this.params1);
    
      // var obj = { ...this.params, ...this.outPutForm };
      // var { c_point_area, c_point_addr, c_point_error, starttime, c_point_number, endtime } = obj;
      // var url = `${this.$config.apiUrl}/xuncha/tongjidownload?c_company_num=${this.cpNum ||
      //   this.$store.state.user.company
      //     .cCompanyNum}&c_point_addr=${c_point_addr}&c_point_error=${c_point_error}&c_point_number=${c_point_number}&starttime=${starttime}&endtime=${endtime}&c_point_area=${c_point_area}`;
      // window.location = url;
    },
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      this.$get('/relic/relicInspectionRecords/getInspectionStatisticsList', this.params).then((res) => {
        // console.log(res,3333);
        this.list = res.rows;
        this.total = res.total;
      });
    },
    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          log(data,33333)
          this.params = { ...this.params, ...data };
          this.params.pageNum = 1;
          this.pageNum = 1;
          this.outPutForm = this.params;

          this.getList();

          this.showDia = false;
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
      this.getList()
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = {
        pageNum: 1,
         pointNum: '',
        pointAddr: '',
         pointError: '',
        startTime: '',
        endTime: '',
        companyNum:  this.$store.state.user.company.cCompanyNum||this.cpNum,
        ...this.$refs.searchForm.models,
      };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
